import React from 'react';
import {AppRouter} from '@/routes/AppRouter'
import {DEFAULT_INTL} from '@/utils/constants/globalConstants'
import {AuthProvider} from '@/context/Auth/AuthProvider'
import useInternationalization from '@/internationalization/useInternationalization'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {IntlProvider} from 'react-intl'
import 'pepsico-ds/css'
import './assets/scss/App.scss'
import {store, persistor} from '@/store'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {ThemeProvider} from 'pepsico-ds'
import {useSetCSSVariables} from '@/utils/constants/colors'
import { ErrorProvider } from '@/context/Error/ErrorContext';
import { useError } from '@/context/Error/ErrorContextUtils';
import GlobalToasterAlert from '@/components/atoms/Toast/GlobalToasterAlert';

const queryClient = new QueryClient({defaultOptions: {queries: {refetchOnWindowFocus: false, retry: 0}}})

function GlobalErrorToaster() {
  const { error, isErrorVisible, hideError } = useError();
  return (
    <GlobalToasterAlert
      type="error"
      message={error}
      show={isErrorVisible && !!error}
      onCloseClick={hideError}
    />
  );
}

function App({shellActive = false, darkTheme = false, path = '',market}) {
  const [language, message] = useInternationalization(DEFAULT_INTL)
  useSetCSSVariables()


  return (
    <ErrorProvider>
      <GlobalErrorToaster />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <IntlProvider locale={language} messages={message}>
              <AuthProvider>
                <ThemeProvider isDarkTheme={true} defaultStyle="Dark Peacock">
                  <AppRouter shellActive={shellActive} darkTheme={darkTheme} path={path} market={market} />
                </ThemeProvider>
              </AuthProvider>
            </IntlProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </ErrorProvider>
  )
}

export default App
